import { render, staticRenderFns } from "./CardiomiopatieEditComponent.vue?vue&type=template&id=9ee7c430&scoped=true"
import script from "./CardiomiopatieEditComponent.vue?vue&type=script&lang=js"
export * from "./CardiomiopatieEditComponent.vue?vue&type=script&lang=js"
import style0 from "./CardiomiopatieEditComponent.vue?vue&type=style&index=0&id=9ee7c430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee7c430",
  null
  
)

export default component.exports